<template>
  <div>
    <v-card>
      <v-layout row justify-center align-center>
        <v-flex xs12>
          <v-card v-if="service.payment">
            <v-toolbar :color="getPaymentColor(service.payment.payment_state)" dark>

              <v-toolbar-title>Pago {{ $t(`enrollments.payment_status.${service.payment.payment_state}`) }}</v-toolbar-title>

            </v-toolbar>

            <v-list
              subheader
              dense
            >
              <v-subheader>Detalle de pago {{ service.service.name }}</v-subheader>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Tipo de pago</v-list-tile-title>
                  <v-list-tile-sub-title>{{ $t(`payments.types.${service.payment.payment_type}`) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Referencia</v-list-tile-title>
                  <v-list-tile-sub-title>{{ service.payment.payment_id }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="service.payment.traceability_code">
                <v-list-tile-content>
                  <v-list-tile-title>Autorización/CUS</v-list-tile-title>
                  <v-list-tile-sub-title>{{ service.payment.traceability_code }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Fecha y hora</v-list-tile-title>
                  <v-list-tile-sub-title>{{ service.payment.updated_at }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="service.quantity">
                <v-list-tile-content>
                  <v-list-tile-title>Cantidad</v-list-tile-title>
                  <v-list-tile-sub-title>{{ service.quantity }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Total</v-list-tile-title>
                  <v-list-tile-sub-title>{{service.payment.payment_currency}} {{ formatNumber(service.payment.service_payment_total) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'payment.verify_qr',
    data() {
      return {
        appUrl: window.config.appUrl,
        service: [],
        token: this.$route.params.token,
        options: {
            maskPattern: 7,
            width: 250,
            color: {
                dark: '#000000',
                light: '#ffffff',
            },
            margin: 1
        }
      }
    },

    created () {
      this.init()
    },

    methods: {
      init() {
        this.token = this.$route.params.token
        axios.get(`/api/school/service/token/${this.token}`)
          .then(resp => {
            if (resp.status === 200) {
              this.service = resp.data.service[0]
            }
          })
      },
      getPaymentColor(payment_state) {
        console.log(payment_state)
        if (payment_state === 'FAILED' ||
                payment_state === 'NOT_AUTHORIZED' ||
                payment_state === 'REJECTED' ||
                payment_state === 'DECLINED' ||
                payment_state === 'VOIDED' ||
                payment_state === 'ERROR' ||
                payment_state == '0') return 'error'

        if (payment_state === 'OK' ||
        payment_state === 'APPROVED') return 'success'

        if (payment_state === 'PENDING' ||
        payment_state === 'iniciado') return 'info'
      },
      formatNumber(number) {
        if(typeof number === 'undefined' || !number) {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/payment/verify_qr.vue